"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isObject = function (value) {
    var type = typeof value;
    return value != null && (type === 'object' || type === 'function');
};
exports.isFunction = function (value) {
    if (!exports.isObject(value))
        return false;
    return typeof value === "function";
};
function shallowEqual(objA, objB) {
    if (objA === objB) {
        return true;
    }
    if (!objA || !objB) {
        return false;
    }
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) {
        return false;
    }
    var hasOwn = Object.prototype.hasOwnProperty;
    for (var i = 0; i < keysA.length; i++) {
        if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
            return false;
        }
    }
    return true;
}
exports.shallowEqual = shallowEqual;
//# sourceMappingURL=helpers.js.map